/**
 * Created by Administrator on 2017/10/27.
 */
import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {HttpService} from "../service/http-service";
import {API} from "../config/api-config";
import {FileUpload} from "../service/file-upload";
declare var alertify:any;
@Component({
  templateUrl:'./leadingPicture.html'
})

export class LeadingPicture implements OnInit{

  constructor(
    private router:Router,
    private http:HttpService,
    private fileupload:FileUpload,
  ){}

  private data:any=[];
  private isShowUpload:any=true;

  private imagePath:string='';

  ngOnInit(): void {
    this.getPath();

  }

  private getPath():void{
    this.http.getData(API.resourcePath)
      .then(res=>{
        this.imagePath=res.data;
        this.getData();
      })
  }

  private getData(){
     this.http.getData(API.banner).then(res=>{
       this.data = res.data;
       if (this.data.length>=5) {
         this.isShowUpload=false
       }
       for (let i=0;i<this.data.length;i++){
         this.data[i].iconEn = this.imagePath+this.data[i].iconEn;
         this.data[i].iconTc = this.imagePath+this.data[i].iconTc;
       }
     });
  }

  private deleteBanner(id:number):void{
    let _self = this;
    alertify.confirm("删除","確定要刪除嗎？",function () {
      _self.http.deleteData(API.banner+"/"+id).then(res=>{
        if(res.status.code==0){
          alertify.success(res.status.message);
          _self.getData();
        }else {
          alertify.error(res.status.message);
        }
      })
    },function () {

    })
  }

  private showIconEn:boolean = false;
  private showIconTc:boolean = false;
  private upload(name:string){
    let self=this;
    this.fileupload.upload(function (res) {
      let temRes=JSON.parse(res);
      if(temRes.status.code==0){
        switch (name){
          case 'iconEn':self.showIconEn=true;break;
          case 'iconTc':self.showIconTc=true;break;
        }
        self.data[name]=temRes.data.fileName;
      }
    });
  }

}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/banner/leadingPicture.components.ts